export const MALL_VALET = 'mall_valet';
